import TriggerConfigSerializer from 'eflex/serializers/trigger-config';

export default class EdhrTriggerConfigSerializer extends TriggerConfigSerializer {}
